import { css } from "@emotion/react"

export const variantMuiGrid = {
  MuiGrid: {
    variants: [
      {
        props: { variant: "outlined", container: true },
        style: ({ theme }) =>
          css`
            padding: 1rem;
            border: 1px solid ${theme.colors.border.primary};
            box-shadow: ${theme.colors.border.primary} 0px 2px 5px;
            border-radius: 0.5rem;
          `,
      },
    ],
  },
}
